import i18n from '@/i18n';

const { t } = i18n;

export const ERROR_DATA = [
  {
    no: 1,
    code: 'SUCCESS',
    desc: t('api_page.documents.error_table.SUCCESS'),
  },
  {
    no: 2,
    code: 'API_KEY_REQUIRED',
    desc: t('api_page.documents.error_table.API_KEY_REQUIRED'),
  },
  {
    no: 3,
    code: 'INVALID_API_KEY',
    desc: t('api_page.documents.error_table.INVALID_API_KEY'),
  },
  {
    no: 4,
    code: 'IP_ADDRESS_NOT_WHITELISTED',
    desc: t('api_page.documents.error_table.IP_ADDRESS_NOT_WHITELISTED'),
  },
  {
    no: 5,
    code: 'REFERENCE_ID_REQUIRED',
    desc: t('api_page.documents.error_table.REFERENCE_ID_REQUIRED'),
  },
  {
    no: 6,
    code: 'REFERENCE_ID_EXISTED',
    desc: t('api_page.documents.error_table.REFERENCE_ID_EXISTED'),
  },
  {
    no: 7,
    code: 'SENDER_ID_REQUIRED',
    desc: t('api_page.documents.error_table.SENDER_ID_REQUIRED'),
  },
  {
    no: 8,
    code: 'SENDER_ID_INVALID',
    desc: t('api_page.documents.error_table.SENDER_ID_INVALID'),
  },
  {
    no: 9,
    code: 'PHONE_NUMBER_REQUIRED',
    desc: t('api_page.documents.error_table.PHONE_NUMBER_REQUIRED'),
  },
  {
    no: 10,
    code: 'PHONE_NUMBER_INVALID',
    desc: t('api_page.documents.error_table.PHONE_NUMBER_INVALID'),
  },
  {
    no: 11,
    code: 'PHONE_NUMBER_LIST_REQUIRED',
    desc: t('api_page.documents.error_table.PHONE_NUMBER_LIST_REQUIRED'),
  },
  {
    no: 12,
    code: 'PHONE_NUMBER_LIST_INVALID',
    desc: t('api_page.documents.error_table.PHONE_NUMBER_LIST_INVALID'),
  },
  {
    no: 13,
    code: 'MAX_PHONE_NUMBER_LIST_EXCEEDED',
    desc: t('api_page.documents.error_table.MAX_PHONE_NUMBER_LIST_EXCEEDED'),
  },
  {
    no: 14,
    code: 'SMS_CONTENT_REQUIRED',
    desc: t('api_page.documents.error_table.SMS_CONTENT_REQUIRED'),
  },
  {
    no: 15,
    code: 'MAX_LENGTH_EXCEEDED',
    desc: t('api_page.documents.error_table.MAX_LENGTH_EXCEEDED'),
  },
  {
    no: 16,
    code: 'NOT_ENOUGH_CREDIT',
    desc: t('api_page.documents.error_table.NOT_ENOUGH_CREDIT'),
  },
  {
    no: 17,
    code: 'PARSE_ERROR',
    desc: t('api_page.documents.error_table.PARSE_ERROR'),
  },
  {
    no: 18,
    code: 'INTERNAL_SERVER_ERROR',
    desc: t('api_page.documents.error_table.INTERNAL_SERVER_ERROR'),
  },
];
